var map = {
	"./black_friday_2023.json": 1341,
	"./cards-effect.json": 1342,
	"./connect-fb-popup.json": 1343,
	"./crop-icon-package-1.json": 1344,
	"./crop-icon-package-10.json": 1345,
	"./crop-icon-package-11.json": 1346,
	"./crop-icon-package-12.json": 1347,
	"./crop-icon-package-13.json": 1348,
	"./crop-icon-package-14.json": 1349,
	"./crop-icon-package-15.json": 1350,
	"./crop-icon-package-16.json": 1351,
	"./crop-icon-package-17.json": 1352,
	"./crop-icon-package-18.json": 1353,
	"./crop-icon-package-19.json": 1354,
	"./crop-icon-package-2.json": 1355,
	"./crop-icon-package-20.json": 1356,
	"./crop-icon-package-21.json": 1357,
	"./crop-icon-package-22.json": 1358,
	"./crop-icon-package-23.json": 1359,
	"./crop-icon-package-24.json": 1360,
	"./crop-icon-package-25.json": 1361,
	"./crop-icon-package-26.json": 1362,
	"./crop-icon-package-27.json": 1363,
	"./crop-icon-package-28.json": 1364,
	"./crop-icon-package-29.json": 1365,
	"./crop-icon-package-3.json": 1366,
	"./crop-icon-package-30.json": 1367,
	"./crop-icon-package-31.json": 1368,
	"./crop-icon-package-32.json": 1369,
	"./crop-icon-package-33.json": 1370,
	"./crop-icon-package-4.json": 1371,
	"./crop-icon-package-5.json": 1372,
	"./crop-icon-package-6.json": 1373,
	"./crop-icon-package-7.json": 1374,
	"./crop-icon-package-8.json": 1375,
	"./crop-icon-package-9.json": 1376,
	"./dailylogin.json": 1377,
	"./easter_2022.json": 1378,
	"./event_quests.json": 1379,
	"./gold_card_animation.json": 1380,
	"./ice_card_animation.json": 1381,
	"./jul4_2022.json": 1382,
	"./loadingscreen.json": 1383,
	"./lucky_wheel.json": 1384,
	"./luckyturnips.json": 1385,
	"./map-package-1.json": 1386,
	"./map-package-10.json": 1387,
	"./map-package-11.json": 1388,
	"./map-package-12.json": 1389,
	"./map-package-13.json": 1390,
	"./map-package-14.json": 1391,
	"./map-package-15.json": 1392,
	"./map-package-16.json": 1393,
	"./map-package-17.json": 1394,
	"./map-package-18.json": 1395,
	"./map-package-19.json": 1396,
	"./map-package-2.json": 1397,
	"./map-package-20.json": 1398,
	"./map-package-21.json": 1399,
	"./map-package-22.json": 1400,
	"./map-package-23.json": 1401,
	"./map-package-24.json": 1402,
	"./map-package-25.json": 1403,
	"./map-package-26.json": 1404,
	"./map-package-27.json": 1405,
	"./map-package-28.json": 1406,
	"./map-package-29.json": 1407,
	"./map-package-3.json": 1408,
	"./map-package-30.json": 1409,
	"./map-package-31.json": 1410,
	"./map-package-32.json": 1411,
	"./map-package-33.json": 1412,
	"./map-package-4.json": 1413,
	"./map-package-5.json": 1414,
	"./map-package-6.json": 1415,
	"./map-package-7.json": 1416,
	"./map-package-8.json": 1417,
	"./map-package-9.json": 1418,
	"./my-pet-minigame.json": 1419,
	"./my_farm.json": 1420,
	"./package_1.json": 1421,
	"./package_2.json": 1422,
	"./payer_reactivation_offer.json": 1423,
	"./pets.json": 1424,
	"./plinko-minigame.json": 1425,
	"./quests.json": 1426,
	"./reward.json": 1427,
	"./rope_card_animation.json": 1428,
	"./savestate_select_popup.json": 1429,
	"./season_pass_atlas.json": 1430,
	"./starchests.json": 1431,
	"./sunday_offer_v2.json": 1432,
	"./valentines_2023.json": 1433,
	"./wheel.json": 1434,
	"./world1.json": 1435,
	"./world10.json": 1436,
	"./world10@0.5x.json": 1437,
	"./world11.json": 1438,
	"./world11@0.5x.json": 1439,
	"./world12.json": 1440,
	"./world12@0.5x.json": 1441,
	"./world13.json": 1442,
	"./world13@0.5x.json": 1443,
	"./world14.json": 1444,
	"./world14@0.5x.json": 1445,
	"./world15.json": 1446,
	"./world15@0.5x.json": 1447,
	"./world16.json": 1448,
	"./world16@0.5x.json": 1449,
	"./world17.json": 1450,
	"./world17@0.5x.json": 1451,
	"./world18.json": 1452,
	"./world18@0.5x.json": 1453,
	"./world19.json": 1454,
	"./world19@0.5x.json": 1455,
	"./world1@0.5x.json": 1456,
	"./world2.json": 1457,
	"./world20.json": 1458,
	"./world20@0.5x.json": 1459,
	"./world21.json": 1460,
	"./world21@0.5x.json": 1461,
	"./world22.json": 1462,
	"./world22@0.5x.json": 1463,
	"./world23.json": 1464,
	"./world23@0.5x.json": 1465,
	"./world24.json": 1466,
	"./world24@0.5x.json": 1467,
	"./world25.json": 1468,
	"./world26.json": 1469,
	"./world26@0.5x.json": 1470,
	"./world27.json": 1471,
	"./world27@0.5x.json": 1472,
	"./world28.json": 1473,
	"./world28@0.5x.json": 1474,
	"./world29.json": 1475,
	"./world29@0.5x.json": 1476,
	"./world2@0.5x.json": 1477,
	"./world3.json": 1478,
	"./world30.json": 1479,
	"./world30@0.5x.json": 1480,
	"./world31.json": 1481,
	"./world31@0.5x.json": 1482,
	"./world32.json": 1483,
	"./world32@0.5x.json": 1484,
	"./world33.json": 1485,
	"./world33@0.5x.json": 1486,
	"./world3@0.5x.json": 1487,
	"./world4.json": 1488,
	"./world4@0.5x.json": 1489,
	"./world5.json": 1490,
	"./world5@0.5x.json": 1491,
	"./world6.json": 1492,
	"./world6@0.5x.json": 1493,
	"./world7.json": 1494,
	"./world7@0.5x.json": 1495,
	"./world8.json": 1496,
	"./world8@0.5x.json": 1497,
	"./world9.json": 1498,
	"./world9@0.5x.json": 1499,
	"./xmas_2021.json": 1500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1340;